(function () {
  var pills = document.querySelectorAll('.offer-pill-nav__pill');
  if (!pills.length) return;

  var sticky = document.querySelector('.offer-sticky-buy');
  var stickyBtn = sticky ? sticky.querySelector('.offer-sticky-buy__btn') : null;
  var currentId = (pills[0].getAttribute('href') || '').replace('#', '');

  function getBuyButton(id) {
    if (!id) return null;
    return document.querySelector('[data-offer-buy="' + id + '"] .offer-showcase__buy-btn');
  }

  function setCurrentId(id) {
    if (!id) return;
    currentId = id;
    updateSticky();
  }

  function chromeOffset() {
    return window.matchMedia('(max-width: 749px)').matches ? 150 : 88;
  }

  function updateSticky() {
    if (!sticky || !stickyBtn) return;
    var buy = getBuyButton(currentId);
    if (!buy) {
      sticky.hidden = true;
      document.body.classList.remove('has-offer-sticky-buy');
      return;
    }

    var rect = buy.getBoundingClientRect();
    var viewport = window.innerHeight || 0;
    var offset = chromeOffset();
    var inView = rect.top < viewport - offset && rect.bottom > 72;

    if (inView || rect.top < 72) {
      sticky.hidden = true;
      document.body.classList.remove('has-offer-sticky-buy');
      return;
    }

    stickyBtn.innerHTML = buy.innerHTML;
    stickyBtn.disabled = buy.disabled;
    sticky.hidden = false;
    document.body.classList.add('has-offer-sticky-buy');
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      pills.forEach(function (pill) {
        pill.classList.remove('offer-pill-nav__pill--active');
      });
      var active = document.querySelector('.offer-pill-nav__pill[href="#' + entry.target.id + '"]');
      if (active) active.classList.add('offer-pill-nav__pill--active');
      setCurrentId(entry.target.id);
    });
  }, { rootMargin: '-20% 0px -60% 0px' });

  document.querySelectorAll('.offer-anchor').forEach(function (anchor) {
    observer.observe(anchor);
  });

  document.querySelectorAll('.offers-hero-video__cta').forEach(function (cta) {
    cta.addEventListener('click', function (event) {
      var href = this.getAttribute('href');
      var target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setCurrentId((href || '').replace('#', ''));
    });
  });

  pills.forEach(function (pill) {
    pill.addEventListener('click', function (event) {
      event.preventDefault();
      var href = this.getAttribute('href');
      var target = document.querySelector(href);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      pills.forEach(function (item) {
        item.classList.remove('offer-pill-nav__pill--active');
      });
      this.classList.add('offer-pill-nav__pill--active');
      setCurrentId((href || '').replace('#', ''));
    });
  });

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var buy = getBuyButton(currentId);
      if (buy && !buy.disabled) buy.click();
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateSticky();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  updateSticky();
})();
